import { render, staticRenderFns } from "./SolePropC.vue?vue&type=template&id=819fda42&scoped=true"
import script from "./SolePropC.vue?vue&type=script&lang=js"
export * from "./SolePropC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819fda42",
  null
  
)

export default component.exports